"use strict";

if (document.getElementById("app_lawyer")) {
  /*var vueAccount = new Vue({
      delimiters: ['[[', ']]'],
      el: '#app_lawyer',
      data: {
          lawyer: [],
          all_social_networks: [],
          lawyerConnected: 0,
          firmName: '',
          secondaryFirmName: '',
          imgYoutube: '',
          lienYoutube: '',
          imgLawyer: '',
          nbSpec: 0,
          languages: [],
          bar_city: '',
          postulations: [],
          degrees: [],
      },
      mounted: function() {
          $.ajaxSetup({ traditional: true });
           if (!localStorage.getItem('my-account-warning')) {
            $('.js-warning').addClass('is-open');
          }
      },
      methods: {
          getLawyer: function(id) {
              let urlApi = '/api/v1/lawyers/'+id;
               $.ajax({
                  url: urlApi,
                  method: 'GET',
                  beforeSend: request => request.setRequestHeader("Accept-Language", languageCode),
                  success: function(response) {
                      vueAccount.lawyer = response;
                      vueAccount.firmName = response.main_law_firm_obj.name;
                      if(response.bar) {
                          vueAccount.bar_city = response.bar_obj.city;
                      }
                      if(response.secondary_law_firm > 0) {
                          vueAccount.secondaryFirmName = response.secondary_law_firm_obj[0].name;
                      }
                      vueAccount.nbSpec = response.specialities.length;
                      if(response.video_id){
                          vueAccount.imgYoutube = 'http://img.youtube.com/vi/'+response.video_id+'/maxresdefault.jpg';
                      } else {
                          vueAccount.imgYoutube = '/static/img/no-avatar.png';
                      }
                       if(response.image == null) {
                          vueAccount.imgLawyer = 'background-image: url(/static/img/no-avatar.png)';
                      } else {
                          vueAccount.imgLawyer = 'background-image: url('+response.image_obj.thumbnail_url+')';
                      }
                       if(response.video_id) {
                          vueAccount.lienYoutube = 'https://www.youtube.com/watch?v='+response.video_id;
                      }
                       vueAccount.problematics = response.problematics;
                      vueAccount.languages = response.spoken_languages;
                       CKEDITOR.replace('more_cv', { customConfig: confCKeditor });
                      CKEDITOR.replace('description', { customConfig: confCKeditor });
                      CKEDITOR.replace('additional_info', { customConfig: confCKeditor });
                      CKEDITOR.replace('hobbies', { customConfig: confCKeditor });
                      CKEDITOR.replace('fees', { customConfig: confCKeditor });
                       setTimeout(function() {
                          initDropsels();
                          $('.js-skill-block').closeSkill();
                          $('.js-skill-show').toggleSkill();
                           // When check skill all linked problematics are checked or not
                          $('.js-skill-checkbox').skillCheckboxes();
                           $('.js-youtube-input').videoID();
                           // Check all lawyer language
                          $('.js-language').languagesForm();
                           // Check automaticly all problematics
                          $('.js-problematic').lawyerProblematics();
                          $('.js-clubs').lawyerClubs();
                          $('.js-secondary-firm').initSecondaryFirm();
                          $('.js-input-bar').initBar();
                           // vueAccount.deleteDegree();
                          vueAccount.deletePostulation();
                          vueAccount.deleteClub();
                          vueAccount.deleteSecondaryFirm();
                          vueAccount.deleteBar();
                          vueAccount.inputChange();
                           if ($('.js-form-social').length) {
                              $('.js-form-social').updateSocialNetworks();
                          }
                           if($('.js-all-forms').length) {
                              $('.js-all-forms').updateAllLawyer(function(){
                                  updateAllInputs();
                              });
                          }
                           var position = $('.js-position').val();
                           $('#status_lawyer option').each(function(){
                              if(position == $(this).val()) {
                                  $(this).attr('selected', true);
                                   var list = $(this).parent().next().next();
                                  list.find('li[data-value='+position+']').trigger('click');
                              }
                          })
                       }, 500);
                  },
                  error: function(error) {
                      console.log(error);
                  }
              });
          },
          updateImage: function(image_id, image) {
               var id = $('.js-lawyer').data('lawyer');
              var dataForm = {
                  "image" : image_id,
              }
               $.ajax({
                  url: '/api/v1/lawyers/' + id,
                  data: dataForm,
                  method: 'PATCH',
                  success: function(response) {
                      $('.js-lawyer-image').css({
                          'background-image' : 'url(' + image + ')'
                      });
                      new Alert().success();
                  },
                  error: function(error) {
                      console.log(error);
                  }
              })
           },
          updateYoutube: function(video_id) {
              vueAccount.lawyer.video_id = video_id;
              vueAccount.imgYoutube = 'http://img.youtube.com/vi/'+video_id+'/maxresdefault.jpg';
              vueAccount.lienYoutube = 'https://www.youtube.com/watch?v='+video_id;
              $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
          },
          getSkills: function() {
              console.log('Init skills');
          },
          getSocialNetwork: function(id) {
               let urlApi = '/api/v1/social_networks';
               $.ajax({
                  url: urlApi,
                  method: 'GET',
                  beforeSend: request => request.setRequestHeader("Accept-Language", languageCode),
                  success: function(response) {
                      vueAccount.lawyerConnected = id;
                      vueAccount.all_social_networks = response;
                      setTimeout(function() {
                          getSocialLawyer();
                          $('.js-delete-social').deleteSocialNetworks();
                      }, 500);
                  },
                  error: function(error) {
                      console.log(error);
                  }
              })
          },
          getPostulations: function(id) {
              let urlApi = '/api/v1/postulations?lawyer='+id;
               $.ajax({
                  url: urlApi,
                  method: 'GET',
                  beforeSend: request => request.setRequestHeader("Accept-Language", languageCode),
                  success: function(response) {
                      // vueAccount.lawyerConnected = id;
                      vueAccount.postulations = response.results;
                  },
                  error: function(error) {
                      console.log(error);
                  }
              })
          },
          getDegrees: function(id) {
              let urlApi = '/api/v1/degrees?lawyer='+id;
              $.ajax({
                  url: urlApi,
                  method: 'GET',
                  beforeSend: request => request.setRequestHeader("Accept-Language", languageCode),
                  success: function(response) {
                      // vueAccount.lawyerConnected = id;
                      vueAccount.degrees = response.results;
                  },
                  error: function(error) {
                      console.log(error);
                  }
              })
          },
          deleteDegree: function() {
               $('.js-delete-degree').on('click', function() {
                   var id = $(this).data('id');
                  var button = $(this);
                   if(id) {
                      $.ajax({
                          url: '/api/v1/degrees/' + id,
                          method: 'DELETE',
                          success: function(response) {
                              button.parent().parent().remove();
                              $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
                          },
                          error: function(error) {
                              console.log(error);
                          }
                      })
                  } else {
                      button.parent().parent().remove();
                  }
              })
          },
          deletePostulation: function() {
               $('.js-delete-postulation').on('click', function() {
                   var id = $(this).data('id');
                  var button = $(this);
                   if(id) {
                      $.ajax({
                          url: '/api/v1/postulations/' + id,
                          method: 'DELETE',
                          success: function(response) {
                              button.parent().remove();
                              $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
                          },
                          error: function(error) {
                              console.log(error);
                          }
                      })
                  } else {
                      button.parent().remove();
                  }
              })
          },
          deleteClub: function() {
              $('.js-delete-club').on('click', function() {
                  $(this).parent().remove();
                  $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
                  $('.js-clubs').lawyerClubs();
              })
          },
          deleteSecondaryFirm: function() {
              $('.js-delete-firm').on('click', function(){
                  $(this).parent().remove();
                  $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
              })
          },
          deleteBar: function() {
              $('.js-delete-bar').on('click', function(){
                  $(this).closest('.js-row-bar').remove();
                  $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
              })
          },
          inputChange: function() {
              var inputs = $('input'),
                  selects = $('.js-select'),
                  checkboxes = $('input[type="checkbox"]');
               // console.log(selects);
               setTimeout(function(){
                   selects.each(function(){
                      var value = $(this).find('option:selected');
                      $(this).on('change', function(){
                          if($(this).find('option:selected') != value) {
                              $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
                          }
                      })
                  })
                   checkboxes.on('change', function(){
                      $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
                  })
               }, 500)
                inputs.each(function(){
                  var value = $(this).val();
                  $(this).on('focusout', function(){
                      if($(this).val() != value) {
                          $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
                      }
                  })
              })
               CKEDITOR.on('instanceReady', function( evt ) {
                  var editor = evt.editor;
                  editor.on( 'blur', function() {
                      console.log('Focus out');
                      $('.js-btn-submit').removeClass('Btn--gray-light').addClass('Btn--gradient-primary');
                  });
              } );
          }
      }
  });
   var lawyerID = $('.js-lawyer').data('lawyer');
  vueAccount.getLawyer(lawyerID);
  vueAccount.getSocialNetwork(lawyerID);
  vueAccount.getPostulations(lawyerID);
  vueAccount.getDegrees(lawyerID);*/
}

function hideWarning() {
  if (document.querySelector('#hide-account-warning').checked) {
    localStorage.setItem('my-account-warning', 'true');
  }

  $('.js-warning').removeClass('is-open');
}

(function ($) {
  $.fn.initSecondaryFirm = function () {
    $(this).each(function () {
      var id = $(this).attr('id');
      inputSecondaryFirm(id);
    });
  };
})(jQuery);

(function ($) {
  $.fn.initBar = function () {
    $(this).each(function () {
      var id = $(this).attr('id');
      inputBar(id);
    });
  };
})(jQuery);

(function ($) {
  $.fn.updateLawyerImage = function () {
    $(this).on('change', function () {
      var formData = new FormData($('.js-form-account'));
      formData.append('image', $(this)[0].files[0]);
      formData.append('attachment', $(this)[0].files[0]);
      formData.append("csrfmiddlewaretoken", $('[name="csrfmiddlewaretoken"]').val());
      $.ajax({
        url: '/api/v1/medias',
        type: 'POST',
        data: formData,
        cache: false,
        contentType: false,
        processData: false,
        beforeSend: function beforeSend() {
          $('.js-loader').show();
          $('.js-loader').addClass('animated');
        },
        success: function success(response) {
          var image_id = response.id,
              image = response.thumbnail_url;
          vueAccount.updateImage(image_id, image);
          $('.js-loader').hide();
          $('.js-loader').removeClass('animated');
        },
        error: function error(_error) {
          console.log(_error);
        }
      });
    });
  };
})(jQuery);

$(function () {
  /*if ($('.js-lawyer-image-input').length) {
      $('.js-lawyer-image-input').updateLawyerImage();
  }*/
});